module.exports = __webpack_public_path__ + "static/media/shopping-pic2.bc5a5d45.jpg";